module.exports = __webpack_public_path__ + "static/media/warning-icon.64c6d38f.svg";